module.exports = __webpack_public_path__ + "img/qr-code@2x.3c325005.png";